module.exports = __webpack_public_path__ + "img/hoja.71b7ef9d.svg";